export default {
      id: "driver-icon-usage",
      viewBox: "0 0 18 21",
      url: __webpack_public_path__ + "img/icons.svg#driver-icon",
      toString: function () {
        return this.url;
      }
    }